import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { makeStyles } from "tss-react/mui";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

//All Loading componants
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { showToast } from "../../../store/actions";
import { ButtonUI, KMKDrawer } from "../../Common";
import SageMakerService from "../../../service/sageMakerService";

const drawerWidth = 420;

const useStyles = makeStyles()((theme) => ({
  heading: {
    color: "#DF672A",
    fontWeight: "bold",
    fontSize: "1rem",
    "& span": {
      fontWeight: "normal",
    },
  },
  closeIcon: {
    padding: 0,
  },
  container: {
    height: "100%",
    padding: "25px 30px",
    "& .errorMessage .MuiPaper-root": {
      marginTop: "20px",
      alignItems: "flex-start",
      border: "none",
    },
    "& .errorMessage .MuiAlert-message": {
      color: "#C72C2C",
    },
    "& .errorMessage": {
      marginBottom: 0,
    },
  },
}));

const UpdateImagePanel = ({ selected, handleClose }) => {
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [image, setImage] = useState("");

  const { classes } = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    const sageMaker = new SageMakerService();
    sageMaker
      .getSpaces()
      .then((response) => {
        if (response.success) setImages(response.data);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleUpdateImage = async () => {
    setLoading(true);

    const sageMaker = new SageMakerService();
    const response = await sageMaker.upgdateImages(selected, image);

    if (response.success) {
      dispatch(
        showToast({
          message: response.message,
          type: "success",
        })
      );
      handleClose(true);
    }

    setLoading(false);
  };

  return (
    <KMKDrawer
      anchor="right"
      open={true}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: "450px" },
          boxSizing: "border-box",
        },
      }}
    >
      <Toolbar />
      <Backdrop sx={{ backgroundColor: "transparent", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="primary" />
      </Backdrop>
      <Box className={classes.container} sx={{ marginBottom: "0" }} role="presentation">
        <Grid container spacing={2}>
          <Grid size={10}>
            <Typography className={classes.heading} variant="h6" gutterBottom component="div">
              Update Image
            </Typography>
          </Grid>
          <Grid size={2}>
            <Button className={classes.closeIcon} onClick={handleClose}>
              <CloseIcon />
            </Button>
          </Grid>
        </Grid>

        <Box
          sx={{
            marginTop: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Update Image to</InputLabel>
            <Select value={image} label="Update Image to" onChange={(e) => setImage(e.target.value)}>
              <MenuItem disabled>Select Image</MenuItem>
              {images.map(({ DisplayName, ImageArn }) => (
                <MenuItem value={ImageArn}>{DisplayName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box my={2}>
          <ButtonUI
            disabled={loading || !image}
            variant="contained"
            color="success"
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleUpdateImage}
          >
            Save
          </ButtonUI>
          <ButtonUI
            variant="contained"
            color="secondary"
            style={{ marginLeft: 15 }}
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleClose}
          >
            Cancel
          </ButtonUI>
        </Box>
      </Box>
    </KMKDrawer>
  );
};

export default UpdateImagePanel;
